import React from 'react';
import {
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Grid,
  LinearProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '../Dialog';
import { inputFieldNames } from '../../constants';
import FancyDropDown from '../FancyDropDown';
import { userRolesEnum } from '../../constants';
import validateEmail from '../../mappers/validateEmail';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  }
}));

const CreateEditUserFormUI = (props) => {
  const {
    openDialog,
    isSaving,
    handleSubmit,
    title,
    user,
    onHandleInputChange,
    openCreateUserDialog,
    branches,
    companies,
    isLoadingBranches,
    isLoadingCompanies,
    actionButtonText = 'Add',
    creatingFromAdmin,
    loggedInUser
  } = props;
  const [isEmailCorrect, setEmailCorrectness] = React.useState(null);

  const classes = useStyles();

  const onDialogClose = () => {
    openCreateUserDialog(false);
  };

  const handleInputChange = (e, inputfieldName) => {
    if (inputfieldName === inputFieldNames.USER_EMAIL) {
      setEmailCorrectness(validateEmail(e.target.value));
    }

    onHandleInputChange(e.target.value, inputfieldName);
  };

  let error;
  if (isEmailCorrect === true) {
    error = false;
  } else if (isEmailCorrect === false) {
    error = true;
  }

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Grid container className={classes.formContainer} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  id="userName"
                  label="Name"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.USER_NAME)
                  }
                  value={user.name}
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  error={error}
                  helperText={error ? 'Incorrect email address' : ''}
                  id="userEmail"
                  label="Email"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.USER_EMAIL)
                  }
                  value={user.email}
                  fullWidth={true}
                />
              </Grid>
              {user.id ? (
                ''
              ) : (
                <Grid item xs={6}>
                  <TextField
                    required
                    type="password"
                    id="password"
                    label="Password"
                    onChange={(e) =>
                      handleInputChange(e, inputFieldNames.USER_PASSWORD)
                    }
                    value={user.password}
                    fullWidth={true}
                  />
                </Grid>
              )}

              {creatingFromAdmin && (
                <Grid item xs={6}>
                  <FancyDropDown
                    htmlId="userRole"
                    label="User Role"
                    margin="normal"
                    value={user.role}
                    handleChange={(e) =>
                      handleInputChange(e, inputFieldNames.USER_ROLE)
                    }
                    items={
                      loggedInUser.role === 4
                        ? userRolesEnum.userRolesEnum.slice(2)
                        : userRolesEnum.userRolesEnum.slice(1)
                    }
                    dropDownWidth="100%"
                    className={classes.dropDown}
                    valueField="id"
                    displayField="value"
                    required
                  />
                </Grid>
              )}

              {creatingFromAdmin && user.role === 3 && (
                <Grid item xs={6}>
                  <div
                    style={{
                      visibility: user.role === 3 ? 'visible' : 'hidden'
                    }}
                  >
                    <FancyDropDown
                      htmlId="branch"
                      label="Branch"
                      margin="normal"
                      value={user.branchId}
                      handleChange={(e) =>
                        handleInputChange(e, inputFieldNames.USER_BRANCH)
                      }
                      items={branches}
                      dropDownWidth="100%"
                      className={classes.dropDown}
                      valueField="id"
                      displayField="name"
                      disabled={isLoadingBranches}
                      required={user.role === 3}
                    />
                  </div>
                </Grid>
              )}

              {creatingFromAdmin && user.role === 4 && (
                <Grid item xs={6}>
                  <div
                    style={{
                      visibility: user.role === 4 ? 'visible' : 'hidden'
                    }}
                  >
                    <FancyDropDown
                      htmlId="company"
                      label="Company"
                      margin="normal"
                      value={user.companyId}
                      handleChange={(e) =>
                        handleInputChange(e, inputFieldNames.USER_COMPANY)
                      }
                      items={companies}
                      dropDownWidth="100%"
                      className={classes.dropDown}
                      valueField="id"
                      displayField="name"
                      disabled={isLoadingCompanies}
                      required={user.role === 4}
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              onClick={onDialogClose}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
              id="cancelButton"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.actionButton}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
              {actionButtonText}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default CreateEditUserFormUI;
